/* @flow */
import React from 'react';

import AuthenticationView from 'auth/components/AuthenticationView.jsx';
import ShareRemind from 'user/components/ShareRemind.jsx';
import ToastActions from 'actions/ToastActions';

class ShareRemindPage extends React.Component {
  componentDidMount() {
    ToastActions.showSuccessToast('Log out successful');
  }

  render() {
    return (
      <AuthenticationView {...this.props} className="ShareRemindPage">
        <div className="ShareRemindPage-share">
          <ShareRemind />
        </div>
      </AuthenticationView>
    );
  }
}

export default ShareRemindPage;



// WEBPACK FOOTER //
// ./src/user/components/ShareRemindPage.jsx